module.exports = __webpack_public_path__ + "static/media/beveler-leatherworking-tool.9f943b49.webp";